import { render, staticRenderFns } from "./ProcesoTabCapacitacion.vue?vue&type=template&id=2008f4f7&"
import script from "./ProcesoTabCapacitacion.vue?vue&type=script&lang=js&"
export * from "./ProcesoTabCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports